define('SuiteDynamics.DescriptionImage.View', [
    'SCView',
    'SuiteDynamics.DescriptionImage.SS2Model',
    'suitedynamics_description_image.tpl'
], function (
    SCViewModule,
    DescriptionImageModel,
    descriptionImageTpl
) {
    'use strict';

    var SCView = SCViewModule.SCView;

    function DescriptionImageView(options) {
        SCView.call(this, options);

        this.template = descriptionImageTpl;
        this.plp = options.plp;
        this.model = new DescriptionImageModel();
        this.data = {};

        console.log('[SD][CategoryBottom] View initialized');

        this.loadCategoryData();
    }

    DescriptionImageView.prototype = Object.create(SCView.prototype);
    DescriptionImageView.prototype.constructor = DescriptionImageView;

    // Read More click event
    DescriptionImageView.prototype.events = {
        'click [data-readmore-toggle]': 'toggleReadMore'
    };

    DescriptionImageView.prototype.loadCategoryData = function () {
        var self = this;
        var categoryInfo = this.plp.getCategoryInfo();
        var categoryId = categoryInfo && categoryInfo.internalid;

        console.log('[SD][CategoryBottom] Category info', categoryInfo);

        if (!categoryId) {
            console.warn('[SD][CategoryBottom] No categoryId');
            return;
        }

        this.model.fetch({
            data: {
                categoryid: categoryId
            }
        })
            .done(function (response) {
                console.log('[SD][CategoryBottom] Service response', response);
                self.data = response || {};
                self.render();
                self.setupReadMore(); // activate read more logic
            })
            .fail(function (err) {
                console.error('[SD][CategoryBottom] Service error', err);
            });
    };

    // Toggle expand/collapse
    DescriptionImageView.prototype.toggleReadMore = function (e) {
        console.log('READ MORE CLICKED');
        var $btn = this.$(e.currentTarget);
        var $content = this.$('[data-readmore-content]');

        if (!$content.length) return;

        var expanded = $content.hasClass('is-expanded');

        if (expanded) {
            $content.removeClass('is-expanded');
            $btn.text('Read more');
        } else {
            $content.addClass('is-expanded');
            $btn.text('Read less');
        }
    };

    // Decide whether to show the button based on real content height
    DescriptionImageView.prototype.setupReadMore = function () {
        var self = this;

        setTimeout(function () {
            var $content = self.$('[data-readmore-content]');
            var $btn = self.$('[data-readmore-toggle]');

            if (!$content.length || !$btn.length) return;

            var collapsedHeight = 160;

            // Show or hide button depending on content height
            if ($content[0].scrollHeight <= collapsedHeight) {
                $btn.hide();
            }

            // Manual click binding for read more toggle
            $btn.off('click.readmore').on('click.readmore', function () {
                console.log('READ MORE CLICKED');

                var expanded = $content.hasClass('is-expanded');

                if (expanded) {
                    $content.removeClass('is-expanded');
                    $btn.text('Read more');
                } else {
                    $content.addClass('is-expanded');
                    $btn.text('Read less');
                }
            });

        }, 0);
    };

    DescriptionImageView.prototype.getContext = function () {
        console.log('[SD][CategoryBottom] getContext raw data', this.data);

        var rawImage = this.data.bottomImage;
        var imageUrl = null;

        // lookupFields case: [{value, text}]
        if (rawImage && Array.isArray(rawImage) && rawImage.length && rawImage[0].text) {
            imageUrl = rawImage[0].text;
        }
        // Direct string case
        else if (typeof rawImage === 'string') {
            imageUrl = rawImage;
        }
        // Object case {url:""}
        else if (rawImage && rawImage.url) {
            imageUrl = rawImage.url;
        }

        var bottomDescription = this.data.bottomDescription || '';
        var customSubtitle = this.data.customSubtitle || '';
        console.log('[SD][CategoryBottom] Parsed imageUrl', imageUrl);

        return {
            customSubtitle: customSubtitle,
            bottomImage: imageUrl,
            bottomDescription: bottomDescription,
            hasImage: !!imageUrl,
            hasDescription: !!bottomDescription,
            showBlock: !!(imageUrl || bottomDescription)
        };
    };

    return DescriptionImageView;
});
